import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import "aos/dist/aos.css"; // It's important to include the CSS file in order to make it work
import "remixicon/fonts/remixicon.css"
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
